/**
 * Product Variants - Enhanced for Multiple Options
 * Handles dynamic availability based on selected options
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Get product data
  const variants = window.productData ? window.productData.variants : [];
  const options = window.productData ? window.productData.options : [];
  
  if (variants.length === 0) {
    // Still provide basic functionality even without variants
    initBasicFunctionality();
    return;
  }
  
  initBasicFunctionality();
  initVariantFunctionality();
  
  function initBasicFunctionality() {
    // Quantity controls
    const quantityInput = document.querySelector('input[name="quantity"]');
    const increaseBtn = document.querySelector('.quantity-increase');
    const decreaseBtn = document.querySelector('.quantity-decrease');
    

  }
  
  function initVariantFunctionality() {
    // Variant selection
    const variantOptions = document.querySelectorAll('.variant-option');
    
    if (variantOptions.length === 0) {
      return;
    }
    
    variantOptions.forEach(function(option) {
      option.addEventListener('change', function() {
        updateVariantAvailability();
        updateVariant();
      });
      
      // Prevent disabled variants from being selected
      option.addEventListener('click', function(e) {
        if (this.disabled || this.closest('.product-varient-input-field').classList.contains('disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });
    
    // Prevent clicking on disabled variant labels
    const variantLabels = document.querySelectorAll('.product-varient-label');
    variantLabels.forEach(function(label) {
      label.addEventListener('click', function(e) {
        if (this.closest('.product-varient-input-field').classList.contains('disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });
    
    // Initialize immediately for single-option products
    initializeVariantStates();
    
    // Initialize on page load with a small delay for multi-option products
    setTimeout(function() {
      updateVariantAvailability();
      updateVariant();
    }, 100);
  }
  
  function initializeVariantStates() {
    // Set initial disabled states based on server-side rendering
    const variantOptions = document.querySelectorAll('.variant-option');
    
    variantOptions.forEach(function(option) {
      const inputField = option.closest('.product-varient-input-field');
      
      if (inputField && inputField.classList.contains('disabled')) {
        option.disabled = true;
      }
    });
  }
  
  function updateVariantAvailability() {
    const variantOptions = document.querySelectorAll('.variant-option');
    
    // Get currently selected options
    const selectedOptions = {};
    
    variantOptions.forEach(function(option) {
      if (option.checked) {
        const optionName = option.name.replace('options[', '').replace(']', '');
        selectedOptions[optionName] = option.value;
      }
    });
    
    // For single option products, we need to check each option value directly
    const optionCount = options ? options.length : Object.keys(selectedOptions).length;
    
    // Update availability for each option
    variantOptions.forEach(function(option) {
      const optionName = option.name.replace('options[', '').replace(']', '');
      const optionValue = option.value;
      const inputField = option.closest('.product-varient-input-field');
      
      if (!inputField) {
        return;
      }
      
      let isAvailable = false;
      
      if (optionCount === 1) {
        // For single option products, check if any variant with this value is available
        isAvailable = variants.some(function(variant) {
          return (variant.option1 === optionValue || 
                  variant.option2 === optionValue || 
                  variant.option3 === optionValue) && variant.available;
        });
      } else {
        // For multiple options, use the existing logic
        const testSelection = { ...selectedOptions };
        testSelection[optionName] = optionValue;
        
        // Check if any variant matches this combination and is available
        isAvailable = variants.some(function(variant) {
          // Check if variant matches the test selection
          let matches = true;
          
          // Use the options array to check each option
          if (options && options.length > 0) {
            options.forEach(function(opt, index) {
              const optionKey = `option${index + 1}`;
              const selectedValue = testSelection[opt.name];
              
              if (selectedValue && variant[optionKey] !== selectedValue) {
                matches = false;
              }
            });
          } else {
            // Fallback: check by option name directly
            const optionKeys = Object.keys(testSelection);
            optionKeys.forEach(function(key, index) {
              const value = testSelection[key];
              if (value) {
                const optionKey = `option${index + 1}`;
                if (variant[optionKey] && variant[optionKey] !== value) {
                  matches = false;
                }
              }
            });
          }
          
          return matches && variant.available;
        });
      }
      
      // Update the UI based on availability
      if (isAvailable) {
        inputField.classList.remove('disabled');
        option.disabled = false;
      } else {
        // Don't disable currently selected option
        if (!option.checked) {
          inputField.classList.add('disabled');
          option.disabled = true;
        }
      }
    });
  }
  
  function updateVariant() {
    const variantOptions = document.querySelectorAll('.variant-option');
    
    // Get selected options using the name attribute format
    const selectedOptions = {};
    
    variantOptions.forEach(function(option) {
      if (option.checked) {
        const optionName = option.name.replace('options[', '').replace(']', '');
        selectedOptions[optionName] = option.value;
      }
    });
    
    // Find matching variant
    let matchedVariant = null;
    
    if (options && options.length > 0) {
      // Use options array for matching
      matchedVariant = variants.find(function(variant) {
        return options.every(function(option, index) {
          const optionKey = `option${index + 1}`;
          const selectedValue = selectedOptions[option.name];
          return !selectedValue || variant[optionKey] === selectedValue;
        });
      });
    } else {
      // Fallback: try to match by position
      const selectedValues = Object.values(selectedOptions);
      matchedVariant = variants.find(function(variant) {
        return selectedValues.every(function(value, index) {
          const optionKey = `option${index + 1}`;
          return !value || variant[optionKey] === value;
        });
      });
    }
    
    if (matchedVariant) {
      // Update variant ID
      const variantInput = document.getElementById('variant-id');
      if (variantInput) {
        variantInput.value = matchedVariant.id;
      }
      
      // Update button
      const addButton = document.querySelector('button[name="add"]');
      if (addButton) {
        if (matchedVariant.available) {
          addButton.disabled = false;
          // Keep original button content but ensure it says "add to bag"
          const buttonText = addButton.innerHTML;
          if (buttonText.includes('Sold Out')) {
            addButton.innerHTML = buttonText.replace('Sold Out', 'add to bag');
          }
        } else {
          addButton.disabled = true;
          // Keep original button content but change text to "Sold Out"
          const buttonText = addButton.innerHTML;
          if (buttonText.includes('add to bag')) {
            addButton.innerHTML = buttonText.replace('add to bag', 'Sold Out');
          }
        }
      }
    }
  }
});